import { render, staticRenderFns } from "./AccountOnboardingSection.vue?vue&type=template&id=8f9a39fe&scoped=true&"
import script from "./AccountOnboardingSection.vue?vue&type=script&lang=js&"
export * from "./AccountOnboardingSection.vue?vue&type=script&lang=js&"
import style1 from "./AccountOnboardingSection.vue?vue&type=style&index=1&id=8f9a39fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a39fe",
  null
  
)

export default component.exports